import { api } from '../config/api';
import API_URL from '../config/api';

export const messageBoardService = {
  // Messages
  getMessages: () => api.get('/api/message-board/messages'),
  createMessage: (data) => api.post('/api/message-board/messages', data),
  updateMessage: (id, data) => api.put(`/api/message-board/messages/${id}`, data),
  deleteMessage: (id) => api.delete(`/api/message-board/messages/${id}`),
  
  // Events
  getEvents: () => api.get('/api/message-board/events'),
  createEvent: (data) => api.post('/api/message-board/events', data),
  updateEvent: (id, data) => api.put(`/api/message-board/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/api/message-board/events/${id}`),
  
  // Pages (Clippy Alerts)
  getPages: () => api.get('/api/message-board/pages'),
  createPage: (data) => api.post('/api/message-board/pages', data),
  acknowledgePage: (id) => api.put(`/api/message-board/pages/${id}/acknowledge`),
  cancelPage: (id) => api.put(`/api/message-board/pages/${id}/cancel`),
  deletePage: (id) => api.delete(`/api/message-board/pages/${id}`),
  
  // Display (public - no auth required)
  getDisplay: async () => {
    const response = await fetch(`${API_URL}/api/message-board/display`);
    return response.json();
  },
  
  // Settings
  getSettings: () => api.get('/api/message-board/settings'),
  updateSettings: (data) => api.put('/api/message-board/settings', data),
};
